export default function (response) {
  if (!response.ok) {
    throw response
  }

  return response.json()
}
